"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORM_ERRORS = void 0;
exports.FORM_ERRORS = {
    invalid_email: 'invalid_email',
    invalid_password: 'invalid_password',
    is_empty: 'is_empty',
    not_equal_to: 'not_equal_to',
    over_max_length: 'over_max_length',
    over_max_value: 'over_max_value',
    under_min_length: 'under_min_length',
    under_min_value: 'under_min_value',
    without_lower_case: 'without_lower_case',
    without_number: 'without_number',
    without_special_character: 'without_special_character',
    without_upper_case: 'without_upper_case',
};
